import { Button } from '@/app/components/button';
import { ButtonGroup } from '@/app/components/button-group';
import {
  type HeaderWithButtonsProps,
  HeaderWrap,
} from '@/app/components/headers/base';
import { createDataAttributes } from '@/app/utils/createDataAttributes';

export const HeaderLevel1 = ({
  title,
  description,
  buttons = [],
  buttonChildren,
  theme = 'light',
  className,
  ...props
}: HeaderWithButtonsProps) => {
  return (
    <HeaderWrap theme={theme} className={className} {...props}>
      {!!title && (
        <h1
          className="font-display text-h1"
          dangerouslySetInnerHTML={{ __html: title }}
          {...createDataAttributes({
            test: 'heading-title',
          })}
        />
      )}
      {!!description && (
        <>
          <hr className="h-1 w-8 border-0 bg-red-500" aria-hidden="true" />
          <div className="flex flex-col gap-y-6 lg:flex-row lg:justify-between lg:gap-x-12">
            <div
              className="font-noto-bold"
              dangerouslySetInnerHTML={{ __html: description }}
              {...createDataAttributes({
                test: 'heading-description',
              })}
            />
            {!!buttonChildren
              ? buttonChildren
              : buttons?.length > 0 && (
                  <ButtonGroup>
                    {buttons.map((button, index) => (
                      <Button
                        key={index}
                        {...button}
                        {...createDataAttributes({
                          test: `heading-button-${index}`,
                        })}
                      />
                    ))}
                  </ButtonGroup>
                )}
          </div>
        </>
      )}
    </HeaderWrap>
  );
};
